// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__fedraSansStdMedium_b11678', '__fedraSansStdMedium_Fallback_b11678'"},"className":"__className_b11678","variable":"__variable_b11678"};